import React from 'react';
import styles from './styles.module.scss';
import StakeForm from './StakeForm';
import StakeStats from './StakeStats';
import WalletConnectConfirmProvider from 'src/Components/WalletConnectConfirmProvider';
const Staking = /*#__PURE__*/React.forwardRef((_, ref) => {
  return /*#__PURE__*/React.createElement(WalletConnectConfirmProvider, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stakeWrapper
  }, /*#__PURE__*/React.createElement(StakeStats, {
    className: styles.stakeStats
  }), /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(StakeForm, {
    className: styles.stakeForm
  })))));
});
Staking.displayName = 'Staking';
export default Staking;